(() => {
    window.addEventListener('urlChange', function (e) {
        document.querySelectorAll('.meta_navigation .languages a').forEach((link) => {
            let href = link.getAttribute('href')
            link.setAttribute('href', (href.indexOf('?') > -1) ? href.split("?")[0] + e.detail.query : href + e.detail.query)
        })
    })
}) ()



